import * as React from "react"
import { Link } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Href } from "../utils/helper"
import { Lang, LangEnum, Trans } from "../utils/lang"

const Footer = ({ config }) => {
  const lang = Lang()

  let footer_slogan = config.footer_slogan || ""
  let menu_branch = config.menu_branch || []
  let menu_japan_tours = config.menu_japan_tours || []
  let menu_luxury_vacations = config.menu_luxury_vacation || []
  let menu_study_trips = config.menu_study_trips || []
  let menu_flight = config.menu_flight || []
  let menu_other_services = config.menu_other_services || []
  let menu_discover = config.menu_discover || []
  let menu_about = config.menu_about || []
  let menu_contact = config.menu_contact || []
  let privacy_policy = config.privacy_policy || {}
  let terms_conditions = config.terms_conditions || {}
  let accessibility = config.accessibility || {}

  const footerMenuLink = (blok) => (
    <li key={blok._uid}>
      <a href={Href(blok.link)} {...storyblokEditable(blok)} className="cursor-pointer text-base hover:text-gray-500">
        {blok.name}
      </a> 
    </li>
  )
  // console.log(menu_japan_tours);

  return (
    <>
      <div className="relative bg-white border-t-2 border-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 px-4 py-6 lg:py-8">
            <div className="flex flex-col items-center md:items-start">
              <Link to={`${lang}/`}>
                <img className="h-auto w-40" src="/img/AMNET-LOGO.svg" alt="Amnet Logo" />
              </Link>
              <p className="text-xl font-serif text-center md:text-left">{footer_slogan}</p>
              <div className="hidden md:block">
                <h2 className="text-base font-bold mt-10">Branches</h2>
                <ul className="border-l border-l-gray-300 ml-4 pl-4">
                  {menu_branch.map(blok => (footerMenuLink(blok)))}
                </ul>
              </div>
            </div>
            
            <div className="hidden md:flex flex-col">
              <h2 className="text-2xl font-bold">{Trans('footer:japanTours')}</h2>
              <div>
                { 
                  menu_japan_tours.map((blok) => {
                    const subMenu = blok.sub_menu.map(sub_blok => footerMenuLink(sub_blok))
                    return (
                      <div key={blok._uid}>
                        <h2 {...storyblokEditable(blok)} className="text-base font-bold mt-5">
                          <a href={Href(blok.link)} className="cursor-pointer">{blok.name}</a>
                        </h2>
                        <ul className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                      </div>
                    )
                  })
                }
              </div>
            </div>

            <div className="hidden md:flex flex-col">
              { lang != LangEnum.JA && 
              <>
              <h2 className="text-2xl font-bold mb-5">Luxury Vacations</h2>
              <div className="mb-5">
                { 
                  menu_luxury_vacations.map((blok) => {
                    const subMenu = footerMenuLink(blok)
                    return (
                      <ul key={blok._uid} className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                    )
                  })
                }
              </div>
              </>
              }
              <h2 className="text-2xl font-bold mb-5">{Trans('footer:studyTrips')}</h2>
              <div>
                { 
                  menu_study_trips.map((blok) => {
                    const subMenu = footerMenuLink(blok)
                    return (
                      <ul key={blok._uid} className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                    )
                  })
                }
              </div>
              <h2 className="text-2xl font-bold my-5">{Trans('footer:flight')}</h2>
              <div>
                { 
                  menu_flight.map((blok) => {
                    const subMenu = footerMenuLink(blok)
                    return (
                      <ul key={blok._uid} className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                    )
                  })
                }
              </div>
              <h2 className="text-2xl font-bold my-5">{Trans('footer:otherServices')}</h2>
              <div>
                { 
                  menu_other_services.map((blok) => {
                    const subMenu = footerMenuLink(blok)
                    return (
                      <ul key={blok._uid} className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                    )
                  })
                }
              </div>
            </div>

            <div className="flex flex-row md:flex-col justify-around md:justify-normal">
              <div className="flex flex-col">
                <h2 className="text-2xl font-bold my-5 md:mt-0">{Trans('footer:discover')}</h2>
                <div>
                  { 
                    menu_discover.map((blok) => {
                      const subMenu = footerMenuLink(blok)
                      return (
                        <ul key={blok._uid} className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                      )
                    })
                  }
                </div>
              </div>
              <div className="flex flex-col">
                <h2 className="text-2xl font-bold my-5">About</h2>
                <div>
                  { 
                    menu_about.map((blok) => {
                      const subMenu = footerMenuLink(blok)
                      return (
                        <ul key={blok._uid} className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                      )
                    })
                  }
                </div>
              </div>
              <div className="hidden md:flex flex-col">
                <h2 className="text-2xl font-bold my-5">{Trans('footer:contact')}</h2>
                <div>
                  { 
                    menu_contact.map((blok) => {
                      const subMenu = footerMenuLink(blok)
                      return (
                        <ul key={blok._uid} className="border-l border-l-gray-300 ml-4 pl-4">{subMenu}</ul>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="md:hidden flex justify-center items-center py-8">
        <img className="w-12 mt-3" src="/icons/footer-mobile-star.svg" alt="footer star" />
        <a href={Trans('telLink')} className="font-serif text-lg px-2">
          {Trans('tel')}
        </a>
        <img className="w-12 mb-3 rotate-180" src="/icons/footer-mobile-star.svg" alt="footer star" />
      </div>

      <footer className="border-t border-dashed p-4 text-xs md:text-sm">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-center md:justify-between">
          <div className="order-2 w-full text-center md:order-1 md:w-auto md:text-left">&copy;Amnet New York, Inc. All Rights Reserved.</div>
          <div className="order-1 w-full md:order-2 md:w-auto mb-4 md:mb-0">
            <div className="flex justify-center">
              <div className="mr-2 md:mr-4"><a href={Href(privacy_policy)}>{Trans('privacyPolicy')}</a></div>
              <div className="mr-2 md:mr-4">|</div>
              <div className="mr-2 md:mr-4"><a href={Href(terms_conditions)}>{Trans('terms&conditions')}</a></div>
              <div className="mr-2 md:mr-4">|</div>
              <div className="mr-0 md:mr-4"><a href={Href(accessibility)}>{Trans('accessibility')}</a></div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
